<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="sc_date"
          :label="customLabel.sc_date || '日期'"
          v-model="form.main.sc_date"
        />
        <customer-field
          slot="sc_custname"
          :label="customLabel.sc_custname || '客户名称'"
          v-model="form.main.sc_custname"
          @select="onSelectCustomer($event)"
        />
        <customer-addr-field
          slot="sc_address"
          :label="customLabel.sc_address"
          v-if="form.main.sc_custid"
          :customer-id="form.main.sc_custid"
          v-model="form.main.sc_address"
        />
        <div class="weui-cell" slot="sc_contact">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sc_contact || "联系人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.sc_contact"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="sc_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sc_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sc_tel"
              placeholder="请输入"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.sc_payments"
          @select="onSelectPayment"
          slot="sc_payments"
          :label="customLabel.sc_payments || '收费方式'"
        />
        <div class="weui-cell" slot="sc_day">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sc_day || "结算日"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sc_day"
              placeholder="0"
            />
          </div>
        </div>
        <currency-field
          slot="sc_currency"
          :label="customLabel.sc_currency || '币别'"
          v-model="form.main.sc_currency"
        />
        <div class="weui-cell" slot="sc_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sc_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sc_taxrate"
              placeholder="0"
            />
          </div>
        </div>
        <div class="weui-cell" slot="sc_feeamount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sc_feeamount || "每次收费金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sc_feeamount"
              placeholder="0"
            />
          </div>
        </div>
        <date-field
          slot="sc_startdate"
          :label="customLabel.sc_startdate || '生效日期'"
          v-model="form.main.sc_startdate"
        />
        <date-field
          slot="sc_enddate"
          :label="customLabel.sc_enddate || '截止日期'"
          v-model="form.main.sc_enddate"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>项目{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <serve-item-field
              slot="scd_siname"
              :label="customLabel.scd_siname || '项目名称'"
              v-model="item.scd_siname"
              :currency="form.main.sc_currency"
              @select="onSelectServeItem($event, item)"
            />
            <div class="weui-cell" slot="si_spec" v-if="item.scd_siname">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.si_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.si_spec }}
              </div>
            </div>
            <div class="weui-cell" slot="scd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.scd_qty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.scd_qty"
                  placeholder="0"
                />
              </div>
              <div class="weui-cell__ft">
                {{item.si_unit}}
              </div>
            </div>
            <div class="weui-cell" slot="scd_price">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.scd_price || "含税单价"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.scd_price"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="scd_amount">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.scd_amount || "金额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ (item.scd_price * item.scd_qty) || 0 }}
              </div>
            </div>
            <div class="weui-cell" slot="scd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.scd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.scd_remark"
                  placeholder="请输入"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import CustomerAddrField from "@/components/field/CustomerAddrField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ServeItemField from "@/components/field/ServeItemField.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    DateField,
    CustomerField,
    CustomerAddrField,
    PaymentField,
    CurrencyField,
    ServeItemField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/sale/servecontract",
      codeField: "sc_code",
      caller: "ServeContract",
      xtype: "make-servecontract-formpanel",
      form: {
        main: {
          sc_address: null
        },
        items: [
          {

          }
        ],
      },
    };
  },
  methods: {
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var main = this.form.main;

      main.sc_custid = selection.id;
      main.sc_custcode = selection.cu_code;
      main.sc_address = null
      main.sc_contact = selection.cc_name;
      main.sc_tel = selection.cc_tel;
    },
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.sc_paymentsid = selection.id;
      // main.cu_paymentscode = selection.pa_code;
    },
    onSelectServeItem(selection, item) {
      item.scd_siid = selection.id
      item.si_spec = selection.si_spec
      item.si_unit = selection.si_unit
      item.scd_price = selection.si_price
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.sc_date) {
        me.$weui.topTips("请选择日期", 2000);
      } else if (!main.sc_custname) {
        me.$weui.topTips("请选择客户", 2000);
      } else if (!main.sc_payments) {
        me.$weui.topTips("请选择收费方式", 2000);
      } else if (!main.sc_day) {
        me.$weui.topTips("请输入结算日", 2000);
      } else if (!main.sc_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else if (!main.sc_feeamount) {
        me.$weui.topTips("请填写每次收费金额", 2000);
      } else if (!main.sc_startdate) {
        me.$weui.topTips("请选择生效日期", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.scd_siname) {
            me.$weui.topTips(`第${count + 1}行项目未选择`, 2000);
            return false;
          } else if (!item.scd_qty) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else if (!item.scd_price) {
            me.$weui.topTips(`第${count + 1}行含税单价未填写`, 2000);
            return false;
          } else {
            item.scd_amount = item.scd_qty * item.scd_price
            count++;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    p_save() {
      const me = this

      me.$loading({
        url: "/api/sale/servecontract/save?caller=ServeContract",
        method: "POST",
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.$router.back()
        }
      })
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;

      const scd_detno = items.length + 1
      items.push({
        scd_detno
      });
    }
  },
};
</script>